import { jsx as s } from "react/jsx-runtime";
import { c as m } from "./index-0371017d.js";
import c, { css as a } from "styled-components";
import "@adobe/aem-spa-page-model-manager";
import { p as d } from "./parseHTMLString-24a59cc8.js";
import "sanitize-html";
import { s as n } from "./sanitizeProps-304c699d.js";
const p = /* @__PURE__ */ c.div.withConfig({
  displayName: "RichTextEditor__StyledRichTextEditor",
  componentId: "sc-3253b316-0"
})([
  "&.RichTextEditor{",
  ";}"
], ({ theme: { components: { richText: i } }, $style: t }) => /* @__PURE__ */ a(i, t));
function l({ text: i = "", replacements: t, className: o, children: r, ...e }) {
  return /* @__PURE__ */ s(p, {
    ...n(e),
    "data-rte-editelement": !0,
    className: m([
      "RichTextEditor",
      o
    ]),
    $style: {
      "--text-color": e.color
    },
    children: r || d(i, t)
  });
}
l.displayName = "RichTextEditor";
const N = (i) => {
  var t;
  return !((t = i.text) != null && t.trim().length);
};
export {
  l as R,
  N as i
};
